import { Box } from 'front-end/src/components'
import React from 'react'
import './TablePagination.less'

const defaultButton = (props) => <button {...props}>{props.children}</button>

interface ITablePaginationProps {
  pages: number
  page: number
  PageButtonComponent: any
  onPageChange: (page: number) => any
  previousText: string
  nextText: string
  paginationContentBefore: any
  paginationContentAfter: any
}

interface ITablePaginationState {
  visiblePages: number[]
}

// TODO refactor to FC
export default class TablePagination extends React.Component<
  ITablePaginationProps,
  ITablePaginationState
> {
  constructor(props) {
    super(props)
    this.state = {
      visiblePages: this.getVisiblePages(props.page + 1, props.pages) || []
    }
  }

  componentDidUpdate(prevProps: ITablePaginationProps): void {
    if (this.props.pages !== prevProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(0, this.props.pages)
      })
      this.changePage(this.props.page + 1)
    }
  }

  filterPages = (visiblePages: number[], totalPages: number) => {
    return visiblePages.filter((page) => page <= totalPages)
  }

  getVisiblePages = (page: number, total: number) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total)
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total]
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total]
      } else {
        return [1, 2, 3, 4, 5, total]
      }
    }
  }

  changePage = (page: number) => {
    const activePage = this.props.page + 1

    if (page === activePage) {
      return
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages)
    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages)
    })
    this.props.onPageChange(page - 1)
  }

  render() {
    const {
      PageButtonComponent = defaultButton,
      paginationContentBefore,
      paginationContentAfter
    } = this.props
    const { visiblePages } = this.state
    const activePage = this.props.page + 1

    return (
      <section className="TablePagination">
        {paginationContentBefore ? paginationContentBefore : <Box />}
        {visiblePages.length > 1 && (
          <div className="TablePagination__wrapper">
            <PageButtonComponent
              className="TablePagination__pageButton"
              onClick={() => {
                if (activePage === 1) return
                this.changePage(activePage - 1)
              }}
              disabled={activePage === 1}
              tabIndex={activePage !== 1 && 0}
            >
              {this.props.previousText}
            </PageButtonComponent>
            {visiblePages.map((page, index, array) => {
              return (
                <PageButtonComponent
                  key={page}
                  className={
                    activePage === page
                      ? 'TablePagination__pageButton TablePagination__pageButton--active'
                      : 'TablePagination__pageButton'
                  }
                  onClick={() => this.changePage(page)}
                  tabIndex={0}
                >
                  {array[index - 1] + 2 < page ? `... ${page}` : page}
                </PageButtonComponent>
              )
            })}
            <PageButtonComponent
              className="TablePagination__pageButton"
              onClick={() => {
                if (activePage === this.props.pages) return
                this.changePage(activePage + 1)
              }}
              tabIndex={activePage !== this.props.pages && 0}
              disabled={activePage === this.props.pages}
            >
              {this.props.nextText}
            </PageButtonComponent>
          </div>
        )}
        {paginationContentAfter}
      </section>
    )
  }
}
